module.exports = __webpack_public_path__ + "img/audio.23349cfb.png";